import styled, { css } from 'styled-components';

import { StyledArrowButton, JourneyHeading } from 'Templates/Clearing/Clearing.styled';

export const Wrapper = styled.div`
    display: inline-block;
    position: relative;
`;

export const StyledButton = styled(StyledArrowButton)`
    ${({ theme }) => css`
        width: 100%;
        margin-top: 0;

        @media ${theme.breakpoints.large.media} {
            width: unset;
        }
    `}
`;

export const Container = styled.div<{
    $hasButton: boolean;
    $clearingPromise: boolean;
}>`
    ${({ theme, $hasButton, $clearingPromise }) => css`
        position: relative;
        background: ${theme.colors.secondary.hex};
        padding: 1rem 0;
        border-radius: 0.5rem;

        ${$clearingPromise &&
        css`
            padding: 1.5rem 1.5rem 1.5rem 1rem;
        `}

        ul {
            padding-left: 1.25rem;
        }

        li {
            list-style-type: square;
        }

        @media ${theme.breakpoints.medium.media} {
            padding: ${$clearingPromise
                ? '1rem 2.5rem 1rem 1.5rem'
                : $hasButton
                ? '1.25rem 0 2.25rem'
                : '1rem 0'};
        }

        @media ${theme.breakpoints.large.media} {
            padding: ${$clearingPromise
                ? '1rem 3.5rem 1rem 1.5rem'
                : $hasButton
                ? '1.5rem 0'
                : '2rem 0'};

            ul {
                padding-left: 2.5rem;
            }
        }

        h2 + p {
            margin-top: 0;
        }

        & :first-child {
            margin-top: 0;
        }

        p:last-of-type {
            margin-bottom: 0;
        }
    `}
`;

export const SupportBlockHeading = styled(JourneyHeading)<{
    $clearingPromise: boolean;
}>`
    ${({ theme, $clearingPromise }) => css`
        width: 100%;
        margin-top: 0;
        margin-bottom: 1rem;

        ${$clearingPromise &&
        css`
            @media ${theme.breakpoints.large.media} {
                font-size: 2rem;
            }
        `}
    `}
`;
